import { styled } from 'goober';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'tippy.js/dist/tippy.css';
import { Outlet } from 'react-router-dom';
import { PageLayout } from '@/page-layout';
import { AppToastContainer } from '@/ui/snackbar/app-toast-container';

export const ErrorAppLayout = () => {
  return (
    <LayoutContainer>
      <MainLayoutWrapper>
        <PageLayout withTopbar={false}>
          <Outlet />
        </PageLayout>

        <AppToastContainer />
      </MainLayoutWrapper>
    </LayoutContainer>
  );
};

const LayoutContainer = styled('div')`
  display: flex;
`;

const MainLayoutWrapper = styled('div')`
  flex-grow: 1;
`;
